import { Component, Injectable } from '@angular/core';
import { ViewController, NavController, ActionSheetController, PopoverController } from 'ionic-angular';

import { AboutPage } from '../../pages/about/about';
import { SocialSharing } from 'ionic-native';


@Component({
  selector: 'app-header-popover',
  template: `
    <ion-list>
      <a href="mailto:info@plusclick.de?subject=Feedback"><button ion-item>Your Feedback</button></a>
      <button ion-item last (click)="share()">Share</button>
    </ion-list>
  `
})
export class AppHeaderPopoverComponent {
  constructor(
    public view: ViewController,
    public nav: NavController,
    public sheet: ActionSheetController,
    public popover: PopoverController,
  ) { }

  close() {
    return this.view.dismiss();
  }

  about() {
    this.nav.push(AboutPage);
  }

  share() {
    let text = 'Firetask - Ionic 2 & Firebase 3 Full Application';
    let url = 'https://firetask.io';
    let actionSheet = this.sheet.create({
      title: 'Spread the World',
      buttons: [
        {
          text: 'Whats App',
          icon: 'whatsapp',
          role: 'whatsapp',
          handler: () => {
            SocialSharing.shareViaWhatsApp(text, null /*Image*/, url)
              .then(() => {
                // alert("Success");
              },
              () => {
                // alert("failed")
              });
          }
        }, {
          text: 'Facebook',
          icon: 'facebook',
          role: 'facebook',
          handler: () => {
            SocialSharing.shareViaFacebook(text, null /*Image*/, url)
              .then(() => {
                // alert("Success");
              },
              () => {
                // alert("failed face");
              });
          }
        },
        {
          text: 'Twitter',
          icon: 'twitter',
          role: 'twitter',
          handler: () => {
            SocialSharing.shareViaTwitter(text, null /*Image*/, url)
              .then(() => {
                // alert("Success");
              },
              () => {
                // alert("failed")
              });
          }
        }, {
          text: 'Others...',
          icon: 'share',
          role: 'others',
          handler: () => {
            SocialSharing.share(text, null/*Subject*/, null/*File*/, url)
              .then(() => {
                // alert("Success");
              },
              () => {
                // alert("failed")
              });
          }
        }
      ]
    });
    this.view.dismiss().then(() => setTimeout(() => actionSheet.present()));
  }
}

@Injectable()
export class AppHeaderPopoverController {

  constructor(public popover: PopoverController) {
  }

  present(event) {
    let popover = this.popover.create(AppHeaderPopoverComponent);
    popover.present({ ev: event });
    event.preventDefault();
  }
}


// WEBPACK FOOTER //
// ./src/components/app-header-popover/app-header-popover.ts